import { Controller } from "@hotwired/stimulus"

// One shared confirmation modal per page, reused by every delete button.
// Usage on the trigger element:
//   data-controller="confirm-modal"
//   data-action="confirm-modal#open"
//   data-confirm-modal-url-value="/admin/products/123"
//   data-confirm-modal-message-value="Supprimer ce produit ?" (optional)
// The modal itself (see shared/_confirm_delete_modal.html.erb) has its own
// data-confirm-modal-target="modal"/"message"/"form" — connected via the
// same controller name so Stimulus wires them together automatically as
// long as both the trigger and the modal sit under a common ancestor with
// data-controller="confirm-modal" (the layout's <body>, in practice).
export default class extends Controller {
  static targets = ["modal", "message", "form"]
  static values = { url: String, message: String }

  connect() {
    if (this.hasModalTarget) {
      this.bsModal = new window.bootstrap.Modal(this.modalTarget)
    }
  }

  open(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.confirmModalUrlValue
    const message = event.currentTarget.dataset.confirmModalMessageValue

    this.formTarget.action = url
    if (message && this.hasMessageTarget) this.messageTarget.textContent = message
    this.bsModal.show()
  }
}
